<template>
  <v-card v-bind="$attrs" :class="classes" class="v-card--material pa-4" :max-width="maxWidth">
    <div class="d-flex grow flex-wrap">
      <v-avatar
        v-if="avatar"
        size="128"
        class="mx-auto v-card--material__avatar elevation-12"
        color="grey"
      >
        <v-img :src="avatar" />
      </v-avatar>

      <v-sheet
        v-else
        :class="{
          'pa-7': !$slots.image,
        }"
        :color="color"
        :max-height="icon ? 90 : undefined"
        :width="inline || icon ? 'auto' : '100%'"
        :elevation="2"
        class="custom-radius text-start v-card--material__heading mb-n6"
        dark
      >
        <slot v-if="$slots.heading" name="heading" />

        <slot v-else-if="$slots.image" name="image" />

        <h4 v-else-if="title && !icon" class="white--text mt-2">
          {{ title }}
        </h4>

        <v-icon v-else-if="icon" size="32" v-text="icon" />

        <div v-if="text" class="headline font-weight-thin" v-text="text" />
      </v-sheet>

      <v-col v-if="hoverReveal" cols="12" class="text-center py-0 mt-n12">
        <slot name="reveal-actions" />
      </v-col>

      <div v-else-if="icon && title" class="custom-width">
        <h3 class="d-none d-md-flex primary--text mt-2 ml-5">
          {{ title }}
        </h3>
        <h4 class="d-flex d-md-none primary--text my-2 ml-2">
          {{ title }}
        </h4>

        <div v-if="$slots['after-heading']" class="text-16 font-weight-medium mt-1 ml-5 primary--text">
          <slot name="after-heading" />
        </div>
      </div>

      <div v-else-if="icon && !title">
        <div v-if="$slots['title']">
          <h3 class="d-none d-md-flex primary--text mt-2 ml-5">
            <slot name="title" />
          </h3>
          <h4 class="d-flex d-md-none primary--text my-2 ml-2">
            <slot name="title" />
          </h4>
        </div>

        <div v-if="$slots['after-heading']" class="text-16 font-weight-medium mt-1 ml-5 primary--text">
          <slot name="after-heading" />
        </div>
      </div>
    </div>

    <slot />

    <template v-if="$slots.actions">
      <v-divider class="mt-2" />

      <v-card-actions class="pb-0">
        <slot name="actions" />
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
export default {
  name: "MaterialCard",

  props: {
    avatar: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "success",
    },
    hoverReveal: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: undefined,
    },
    image: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    maxWidth: {
      type: String,
      default: "100%",
    },
  },

  computed: {
    classes() {
      return {
        "v-card--material--has-heading": this.hasHeading,
        "v-card--material--hover-reveal": this.hoverReveal,
      };
    },
    hasHeading() {
      return Boolean(this.$slots.heading || this.title || this.icon);
    },
    hasAltHeading() {
      return Boolean(this.$slots.heading || (this.title && this.icon));
    },
  },
};
</script>

<style lang="scss">
.custom-radius {
  border-radius: 10px;
}
.custom-width {
  min-width: 200px;
}
</style>
<style lang="sass">
.v-card--material
  &__avatar
    position: relative
    top: -64px
    margin-bottom: -32px

  &__heading
    position: relative
    top: -40px
    transition: .3s ease
    z-index: 1

  &.v-card--material--hover-reveal:hover
    .v-card--material__heading
      transform: translateY(-40px)
</style>
